import styled from "@emotion/styled";
import { ursaColors } from "@smartsheet/design-tokens";
import { LabelHTMLAttributes, ReactNode } from "react";
import { danger, neutralDark30 } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";
import { RequiredThemeKeys, themed } from "../../../util/theme";
import { TypeRampV2 } from "../../typography";
import { FormLabelValidationState } from "../types";

export const labelVariantProps = {
    oldestar: {
        system: "lodestar",
        variant: "bodyStrong",
    },
    "lodestar-light": {
        system: "lodestar",
        variant: "bodyStrong",
    },
    "ursa-light": {
        system: "ursa",
        variant: "Inter--12px--600w",
    },
} as const;

const labelStyles = themed({
    color: {
        rest: { "lodestar-light": neutralDark30, "ursa-light": ursaColors.neutral800 },
        error: { "lodestar-light": danger, "ursa-light": ursaColors.neutral800 },
    },
});

interface FormLabelLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    children: ReactNode;
    themeMode: RequiredThemeKeys;
    validationState: FormLabelValidationState | undefined;
}

export const FormLabelLabel = styled(TypeRampV2)<FormLabelLabelProps>`
    margin-bottom: ${sizes.xSmall}px;
    color: ${({ themeMode, validationState }) =>
        validationState === "error" ? labelStyles.color.error(themeMode) : labelStyles.color.rest(themeMode)};
`;
